// extracted by mini-css-extract-plugin
export default {"demo":"App_demo__UQRPr","darkModeClassThatDoesntWork":"App_darkModeClassThatDoesntWork__O9hyv","dark":"App_dark__TE4we"};